/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { PRODUCTS: de },
  'el-GR': { PRODUCTS: el },
  'en-US': { PRODUCTS: en },
  'es-ES': { PRODUCTS: es },
  'fi-FI': { PRODUCTS: fi },
  'fr-FR': { PRODUCTS: fr },
  'it-IT': { PRODUCTS: it },
  'pl-PL': { PRODUCTS: pl },
  'pt-PT': { PRODUCTS: pt }
};
